import { render, staticRenderFns } from "./DynamicConfirmation.vue?vue&type=template&id=2e35d88c"
import script from "./DynamicConfirmation.ts?vue&type=script&lang=ts&external"
export * from "./DynamicConfirmation.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports